export default __webpack_public_path__ + "static/media/whiteArgo.ede8454b.svg";